import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { MessageComposeForm } from '@/features/messages/components/MessageComposeForm'

export default function AdminMessageComposePage() {
  const navigate = useNavigate()
  const { t } = useTranslation(['admin', 'messages'])

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h1 className="text-2xl font-bold mb-6">{t('messages:compose.title')}</h1>

      <div className="bg-white rounded-lg shadow p-6">
        <MessageComposeForm
          onSuccess={() => navigate('/admin/messages')}
          onCancel={() => navigate('/admin/messages')}
        />
      </div>
    </div>
  )
}
